import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import { useEffect, useState } from 'react'
import { TableCellHead, TableContainer } from 'src/components'
import NoResultsTable from 'src/components/NoResultsTable'
import StatusIntegracaoBadge from 'src/modules/programacoes/StatusIntegracaoBadge'
import { formatDateTime } from 'src/utils/formatters/formatDate'
import { getIntegracaoTabelaFrete } from '../hooks/lotesRepository'
import { IntegracaoTabelaFreteLog } from '../types'

interface Props {
  open: boolean
  loteId: string
  onClose: () => void
}

const ETAPAS: Record<string, string> = {
  VRAPI_POST_RODFRA: 'Tabela de Frete',
  VRAPI_POST_RODTCL: 'Tabela por Cliente',
  VRAPI_POST_AJUSTE_RODFRA: 'Reajuste de Valores',
  VRAPI_GET_CODLIN: 'Consulta de linha',
  VRAPI_POST_RODPRC: 'Criação de PC'
}

export function HistoricoIntegracaoTabelaFrete({
  open,
  loteId,
  onClose
}: Props) {
  const [logs, setLogs] = useState<IntegracaoTabelaFreteLog[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open) return

    async function carregar() {
      setLoading(true)

      const response = await getIntegracaoTabelaFrete(loteId)
      setLogs(response.ok && response.data ? response.data : [])

      setLoading(false)
    }

    carregar()
  }, [open, loteId])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Histórico de integração do lote</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer
              totalCount={logs.length}
              loading={loading}
              disabledPagination
            >
              {logs.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCellHead label="Data" />
                      <TableCellHead label="Etapa" />
                      <TableCellHead label="Status" />
                      <TableCellHead label="Mensagem" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {logs.map(log => (
                      <TableRow key={log.id}>
                        <TableCell>{formatDateTime(log.createdAt)}</TableCell>
                        <TableCell>
                          {ETAPAS[log.proc] ?? log.proc}
                          {log.motivo ? ` (${log.motivo})` : ''}
                        </TableCell>
                        <TableCell>
                          <StatusIntegracaoBadge status={log.status} />
                        </TableCell>
                        <TableCell>
                          {log.mensagemErro ??
                            log.resposta?.LOG_INTEGRACAO ??
                            '—'}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <NoResultsTable loading={loading} />
              )}
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
